import React, { useRef, useState } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

function ImageCrop({
  modalOpen,
  setModalOpen,
  uploadedImage,
  setUploadedImage
}) {
  const modalContent = useRef(null);
  const imgRef = useRef(null);

  const [crop, setCrop] = useState({
    unit: '%', // Can be 'px' or '%'
    x: 10,
    y: 10,
    width: 80,
    height: 80
  });
  const [completedCrop, setCompletedCrop] = useState(null);

  const handleCompleteCrop = (crop) => {
    makeClientCrop(crop);
  };

  const makeClientCrop = async (crop) => {
    if (imgRef.current && crop.width && crop.height) {
      const croppedData = await getCroppedImg(
        imgRef.current,
        crop,
        "newFile.png"
      );
      setCompletedCrop(croppedData);
    }
  };

  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }

          resolve(blob);
        },
        "image/png",
        1
      );
    });
  };

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white overflow-auto max-w-2xl w-full max-h-full rounded-2xl shadow-lg flex flex-col"
        >
          <div className="py-8 px-6 space-y-5 flex justify-center">
            <ReactCrop
              crop={crop}
              onChange={setCrop}
              //   aspect={1}
              onComplete={handleCompleteCrop}
            >
              {uploadedImage && (
                <img
                  ref={imgRef}
                  src={URL.createObjectURL(uploadedImage[0])}
                  alt="cropper"
                  className="w-full h-[400px] object-cover"
                />
              )}
            </ReactCrop>
          </div>
          <div className="my-2 flex justify-center space-x-4">
            <button
              className="md:w-52 btn bg-white border-slate-200 hover:border-slate-300 text-[#1E293B] text-sm font-semibold leading-5 cursor-pointer"
              onClick={(e) => setModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="md:w-52 btn bg-[--bg-color-500] text-white cursor-pointer"
              onClick={(e) => {
                if (completedCrop) {
                  console.log("submit clicked ==>", {completedCrop});
                  setUploadedImage([completedCrop]);
                }
                setModalOpen(false);
              }}
            >
              Save
            </button>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default ImageCrop;
